import { render, staticRenderFns } from "./Zspj.vue?vue&type=template&id=4eb71f13&scoped=true"
import script from "./Zspj.vue?vue&type=script&lang=js"
export * from "./Zspj.vue?vue&type=script&lang=js"
import style0 from "./Zspj.vue?vue&type=style&index=0&id=4eb71f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb71f13",
  null
  
)

export default component.exports